import { FLIP_DURATION } from './const';
import _ from 'lodash';
import { playSound, delay, dbget, dbdel, dbset } from '../HOME/utils';
import { FAST } from '../HOME/const';

const MaxSteps = [20, 40, 60, 80, 100];

const baseKey = props => {
  const { size } = props;
  return `SM • ${size} • `;
};

export const boardKey = props => {
  return `${baseKey(props)}BOARD`;
};

export const statsKey = props => {
  return `${baseKey(props)}STATS`;
};

export const getStats = (props, resolve) => {
  const key = statsKey(props);
  dbget(key, stats => {
    if (!stats) {
      stats = { plays: 0, aggScore: 0, bestScore: 0 };
    }

    resolve(stats);
  });
};

export const getMoreStats = (stats, size, steps) => {
  let { plays, aggScore, aveScore, bestScore } = stats || {};

  if (!aveScore) {
    aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);
  }

  const score = calcScore(steps || 0, size);
  const grade = _.round(((aveScore || 0) * Math.min(10, plays || 0)) / 10.0);
  return { plays, aveScore, bestScore, grade, score };
};

export const setStats = (props, surrender) => {
  dbdel(boardKey(props));

  let { steps, stats, size } = props;
  let { plays, aggScore, bestScore } = stats || {};

  plays = (plays || 0) + 1;
  steps = steps || 0;
  let score = 0;

  if (surrender) {
    steps = Math.max(steps, MaxSteps[size - 1]);
  } else {
    score = calcScore(steps, size);

    if (score === 1000) {
      score = 0;
    }
  }

  aggScore = (aggScore || 0) + score;

  bestScore = Math.max(score, bestScore || 0);

  const key = statsKey(props);
  stats = { plays, aggScore, bestScore };

  dbset(key, stats);
  props.updateStats(stats);
};

export const calcScore = (steps, size) => {
  const score = _.round(1000 * (1 - steps / MaxSteps[size - 1]));
  return Math.max(score, 10);
};

export const sizeInfo = size => {
  switch (size) {
    case 1:
      return { rows: 3, cols: 3, cellCount: 9, name: 'XS' };
    case 2:
      return { rows: 4, cols: 3, cellCount: 12, name: 'S' };
    case 3:
      return { rows: 4, cols: 4, cellCount: 16, name: 'M' };
    case 4:
      return { rows: 5, cols: 4, cellCount: 20, name: 'L' };
    case 5:
      return { rows: 5, cols: 5, cellCount: 25, name: 'XL' };
    default:
  }
};

export const getDest = cell => {
  const dest = cell.dest || cell;
  return { row: dest.row, col: dest.col };
};

export const validateCells = (props, cells, actOnOver = true) => {
  cells = cells || props.cells;
  let over = true;

  _.each(cells, cell => {
    const { row, col } = cell.dest || cell;

    cell.valid = true;

    for (let i = 0; i < 4; i++) {
      var adj = getAdjacent(cells, row, col, i, props.size);

      if (!isValidPair(cell, adj)) {
        cell.valid = false;
        over = false;
        break;
      }
    }
  });

  if (!over) {
    props.setBlock(false);
  } else if (actOnOver) {
    props.forceUpdate();
    props.setBlock(true);

    delay(() => {
      playSound(props, 'won');
      props.setOver(true);
      props.setBlock(false);
    }, FAST);
  }

  return over;
};

export const getAdjacent = (cells, row, col, side, size) => {
  switch (side) {
    case 0:
      --col;
      break;
    case 1:
      --row;
      break;
    case 2:
      ++col;
      break;
    case 3:
      ++row;
      break;
    default:
  }

  const { rows, cols } = sizeInfo(size);

  if (row < 1 || col < 1 || row > rows || col > cols) {
    return null;
  }

  const i = (row - 1) * cols + col - 1;
  return cells[i];
};

export const isValidPair = (c1, c2) => {
  if (!c1 || !c2) {
    return true;
  }

  return (c1.color === c2.color && c1.shape !== c2.shape) || (c1.shape === c2.shape && c1.color !== c2.color);
};

export const restart = props => {
  props.setInit(true);
  delay(() => props.setRestart(true), FLIP_DURATION);
};

export const sameCell = (ob1, ob2) => {
  return ob1 && ob2 && ob1.row === ob2.row && ob1.col === ob2.col;
};
